export default function Initials({ value }) {
  const getInitials = (name) => {
    let words = name.split(' ');
    if (words.length > 1) {
      let firstWordIndex = 0;
      while (firstWordIndex < words.length && words[firstWordIndex] === '') {
        firstWordIndex++;
      }

      let lastWordIndex = words.length - 1;
      while (lastWordIndex >= 0 && words[lastWordIndex] === '') {
        lastWordIndex--;
      }

      if (firstWordIndex < words.length && lastWordIndex >= 0) {
        return words[firstWordIndex].charAt(0).toUpperCase() + words[lastWordIndex].charAt(0).toUpperCase();
      } else {
        return '';
      }
    } else {
      return name.split(' ').map(part => part.charAt(0).toUpperCase()).join('');
    }
  };

  return typeof value === 'string' ? getInitials(value) : null;
}
